// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1M6M3","clinicsSelect":"TableHeading_clinicsSelect__24uWt"};